export const BORROWER = [
  {
    documentName: "สำเนาบัตรประชาชน",
    isSend: "true",
    documentCode: "000",
    documentDescription: "สำเนาบัตรประจำตัวประชาชน ฉบับที่ไม่หมดอายุเท่านั้น",
    refType: "REQUES.BORROWER.ATTACHEDFILE"
  },
  {
    documentName: "สำเนาทะเบียนบ้าน",
    isSend: "true",
    documentCode: "001",
    documentDescription: "",
    refType: "REQUES.BORROWER.ATTACHEDFILE"
  },
  {
    documentName: "สำเนาเปลี่ยนชื่อ สกุล",
    documentCode: "002",
    documentDescription: "",
    refType: "REQUES.BORROWER.ATTACHEDFILE"
  },
  {
    documentName: "ใบรับรองแพทย์",
    documentCode: "003",
    documentDescription: "กรณีผู้กู้มีอายุ 80 ปีขึ้นไป",
    refType: "REQUES.BORROWER.ATTACHEDFILE"
  },
  {
    documentName: "รูปถ่ายเต็มตัวขณะประกอบอาชีพ",
    documentCode: "004",
    documentDescription:
      "รูปถ่ายผู้กู้ยืมที่แสดงว่าประกอบอาชีพจริงตามที่ยื่นคำร้อง",
    refType: "REQUES.BORROWER.ATTACHEDFILE"
  },
  {
    documentName: "สมุดคู่บัญชีการกู้ยืมฯ สำเนาเอกสารทะเบียนคุมลุกหนี้",
    documentCode: "005",
    documentDescription:
      "กรณีเคยเป็นลูกหนี้มาก่อนและชำระหนี้ครบถ้วนแล้วต้องมีเอกสารยืนยันว่าชำระหนี้ครบถ้วน",
    refType: "REQUES.BORROWER.ATTACHEDFILE"
  },
  {
    documentName: "สำเนาสมุดบัญชีธนาคาร",
    isSend: "true",
    documentCode: "006",
    documentDescription: "",
    refType: "REQUES.BORROWER.ATTACHEDFILE"
  },
  {
    documentName: "แผนผังสถานที่ประกอบอาชีพ",
    documentCode: "007",
    documentDescription: "",
    refType: "REQUES.BORROWER.ATTACHEDFILE"
  }
];
export const SPOUSE = [
  {
    documentName: "หนังสือยินยอมคู่สมรส",
    isSend: "true",
    documentCode: "006",
    documentDescription: "",
    refType: "REQUES.SPOUSE.ATTACHEDFILE"
  },
  {
    documentName: "สำเนาบัตรประชาชน",
    isSend: "true",
    documentCode: "000",
    documentDescription: "สำเนาบัตรประจำตัวประชาชน ฉบับที่ไม่หมดอายุเท่านั้น",
    refType: "REQUES.SPOUSE.ATTACHEDFILE"
  },
  {
    documentName: "สำเนาทะเบียนบ้าน",
    isSend: "true",
    documentCode: "001",
    documentDescription: "",
    refType: "REQUES.SPOUSE.ATTACHEDFILE"
  },
  {
    documentName: "สำเนาเปลี่ยนชื่อ สกุล",
    documentCode: "002",
    documentDescription: "",
    refType: "REQUES.SPOUSE.ATTACHEDFILE"
  },
  {
    documentName: "สำเนาใบสำคัญสมรส",
    isSend: "true",
    documentCode: "007",
    documentDescription: "",
    refType: "REQUES.SPOUSE.ATTACHEDFILE"
  },
  {
    documentName: "สำเนาใบสำคัญหย่า",
    isSend: "true",
    documentCode: "008",
    documentDescription: "",
    refType: "REQUES.SPOUSE.ATTACHEDFILE"
  },
  {
    documentName: "ใบมรณะบัตร",
    isSend: "true",
    documentCode: "009",
    documentDescription: "กรณีที่ผู้สมรสเสียชีวิต",
    refType: "REQUES.SPOUSE.ATTACHEDFILE"
  }
];
export const GUARANTOR = [
  {
    documentName: "สำเนาบัตรประชาชน",
    isSend: "true",
    documentCode: "000",
    documentDescription: "สำเนาบัตรประจำตัวประชาชน ฉบับที่ไม่หมดอายุเท่านั้น",
    refType: "REQUES.GUARANTOR.ATTACHEDFILE"
  },
  {
    documentName: "สำเนาทะเบียนบ้าน",
    isSend: "true",
    documentCode: "001",
    documentDescription: "",
    refType: "REQUES.GUARANTOR.ATTACHEDFILE"
  },
  {
    documentName: "สำเนาเปลี่ยนชื่อ สกุล",
    documentCode: "002",
    documentDescription: "",
    refType: "REQUES.GUARANTOR.ATTACHEDFILE"
  },
  {
    documentName: "หนังสือรับรองเงินเดือน",
    isSend: "true",
    documentCode: "010",
    documentDescription:
      "หนังสือรับรองเงินเดือนผู้ค้ำประกันฉบับจริงซึ่งออกให้ไม่เกิน 3 เดือนนับจากวันที่ออก หรือสำเนาสลิปเงินเดือนย้อนหลัง 3 เดือน",
    refType: "REQUES.GUARANTOR.ATTACHEDFILE"
  },
  {
    documentName: "",
    isSend: "true",
    documentCode: "011",
    documentDescription:
      "หนังสือรับรองเงินเดือนผู้ค้ำประกันฉบับจริงซึ่งออกให้ไม่เกิน 3 เดือนนับจากวันที่ออก หรือสำเนาสลิปเงินเดือนย้อนหลัง 3 เดือน",
    refType: "REQUES.GUARANTOR.ATTACHEDFILE"
  },
  {
    documentName: "",
    isSend: "true",
    documentCode: "012",
    documentDescription:
      "หนังสือรับรองเงินเดือนผู้ค้ำประกันฉบับจริงซึ่งออกให้ไม่เกิน 3 เดือนนับจากวันที่ออก หรือสำเนาสลิปเงินเดือนย้อนหลัง 3 เดือน",
    refType: "REQUES.GUARANTOR.ATTACHEDFILE"
  }
];
export const GUARANTORSPOUSE = [
  {
    documentName: "หนังสือยินยอมคู่สมรส",
    isSend: "true",
    documentCode: "006",
    documentDescription: "",
    refType: "REQUES.GUARANTORSPOUSE.ATTACHEDFILE"
  },
  {
    documentName: "สำเนาบัตรประชาชน",
    isSend: "true",
    documentCode: "000",
    documentDescription: "สำเนาบัตรประจำตัวประชาชน ฉบับที่ไม่หมดอายุเท่านั้น",
    refType: "REQUES.GUARANTORSPOUSE.ATTACHEDFILE"
  },
  {
    documentName: "สำเนาทะเบียนบ้าน",
    isSend: "true",
    documentCode: "001",
    documentDescription: "",
    refType: "REQUES.GUARANTORSPOUSE.ATTACHEDFILE"
  },
  {
    documentName: "สำเนาเปลี่ยนชื่อ สกุล",
    documentCode: "002",
    documentDescription: "",
    refType: "REQUES.GUARANTORSPOUSE.ATTACHEDFILE"
  },
  {
    documentName: "สำเนาใบสำคัญสมรส",
    isSend: "true",
    documentCode: "007",
    documentDescription: "",
    refType: "REQUES.GUARANTORSPOUSE.ATTACHEDFILE"
  },
  {
    documentName: "สำเนาใบสำคัญหย่า",
    isSend: "true",
    documentCode: "008",
    documentDescription: "",
    refType: "REQUES.GUARANTORSPOUSE.ATTACHEDFILE"
  },
  {
    documentName: "ใบมรณะบัตร",
    isSend: "true",
    documentCode: "009",
    documentDescription: "กรณีที่ผู้สมรสเสียชีวิต",
    refType: "REQUES.GUARANTORSPOUSE.ATTACHEDFILE"
  }
];

